import {Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {AnalyticsService} from '../../../../services/analytics/analytics.service';
import {CustomerCampaignService} from '../../../../services/customer/customer-campaign.service';
import {TranslateService} from '@ngx-translate/core';
import {SearchToolbarModel} from '../../../../modules/UIKit/components/searchToolBar/search-toolbar.model';
import {NumberPrefix} from '../../../../modules/UIKit/pipes/NumberPrefix';
import {DateListModel} from '../../../../services/analytics/analytics.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { Observable } from 'rxjs/Observable';
import { IndicatorsService } from '../../../../services/indicators/indicators.service';

@Component({
    selector: 'app-revenue-analysis-trend',
    templateUrl: './revenue-analysis-trend.component.html'
})
export class RevenueAnalysisTrendComponent implements OnInit {
    show_results = false;
    data: QFilterModel;
   // @Input() toolbarValues: SearchToolbarModel;
    type_results = 'NOTHING'; // ONLY_CARD, ALL
    elapsedStart: Date;
    elapsedEnd: Date;
    optionRevenue = {};
    chartRevenue: any;
    chart_revenue: LoyaltyChart;
    optionScontrini = {};
    chartScontrini: any;
    chart_scontrini: LoyaltyChart;
    optionActiveCustomers = {};
    chartActiveCustomers: any;
    chart_active_customers: LoyaltyChart;
    optionCardPenetration = {};
    chartCardPenetration: any;
    chart_card_penetration: LoyaltyChart;
    optionCardRelease = {};

    /*@HostListener('window:resize') onResize() {
        console.log('resizing');
        if (this.type_results !== 'NOTHING') {
            this.plotChart(this.chartRevenue);
            this.plotChart(this.chartScontrini);
        }
        if (this.type_results === 'ALL') {
            this.plotChart(this.chartActiveCustomers);
            this.plotChart(this.chartCardPenetration);
            this.plotChart(this.chartCardRelease);
        }
    }*/

    constructor(public indicatorService: IndicatorsService,
                public svcAnalytics: AnalyticsService,
                public svcCustomerCampaign: CustomerCampaignService,
                public translate: TranslateService,
                public numberPrefix: NumberPrefix) {
    }

    ngOnInit(): void {
/*
        if (this.svcAnalytics.card_modes == null || this.svcAnalytics.card_modes.length === 0) {
            this.svcAnalytics.getCardModes().subscribe();
        }
        if (this.svcAnalytics.group_types_formatted == null || this.svcAnalytics.group_types_formatted.length === 0) {
            this.svcAnalytics.getGroupTypesFormatted().subscribe();
        }
        if (this.svcAnalytics.date_commercial_list == null) {
            this.svcAnalytics.getDatesCommercial().subscribe();
        }
        if (this.svcAnalytics.stores_combo == null || this.svcAnalytics.stores_combo.length === 0) {
            this.svcAnalytics.getStoreComboList().subscribe();
        }*/
        this.chart_revenue = new LoyaltyChart('line');
        this.chart_scontrini = new LoyaltyChart('line');
        this.chart_active_customers = new LoyaltyChart('line');
        this.chart_card_penetration = new LoyaltyChart('line');
    }

    setChartInstance(chart: LoyaltyChart, chartInstance) {
        chart.instance = chartInstance;
    }

    buildChartOption(title_key, yType, y_title_key, category, current_series, prev_series): any {
        let opt = {};
        const self = this;
        this.translate.get([title_key,
            y_title_key,
            'customers.chart_sales_period',
            'customers.current',
            'customers.previous'
        ]).subscribe(tr => {
            opt = {
                chart: {zoomType: 'xy'},
                title: {text: tr[title_key]},
                yAxis: {
                    title: {text: tr[y_title_key]},
                    labels: {
                        formatter: function () {
                            return self.numberPrefix.transform(this.value) + yType
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    categories: category,
                    title: {text: tr['customers.chart_sales_period']},
                    labels: {
                        align: 'right',
                        rotation: -90
                    }
                },
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false
                        }
                    }
                },
                series: [
                    {
                        name: tr['customers.previous'],
                        data: prev_series,
                        color: '#9ab5e5'
                    },
                    {
                        name: tr['customers.current'],
                        data: current_series,
                        color: '#395a94'
                    }
                ],
                responsive: {
                    rules: [{
                        condition: {maxWidth: 500},
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }

            }

        });
        return opt;

    }



    displayTrend (mode) {
        let d = this.data;

        Observable.zip (
            this.indicatorService.getChart('customers.Q018', d, false)
        ).subscribe( (res) => {

            let res_year = res[0].series[0].serie;
            let res_month = res[0].series[1].serie;
            let res_revenue = res[0].series[2].serie;
            let res_revenue_prev = res[0].series[3].serie;
            let res_scontrini = res[0].series[4].serie;
            let res_scontrini_prev = res[0].series[5].serie;

            let category = [];
            let cur_rev_series = [];
            let prev_rev_series = [];
            let cur_sc_series = [];
            let prev_sc_series = [];
            this.elapsedStart = new Date (this.data.start_date);
            this.elapsedEnd = new Date (this.data.end_date);

            for (let i = 0; i < res_year.length; i++) {
                category.push (res_year[i] /*+ res_month[i]*/);
                cur_rev_series.push(res_revenue[i]);
                prev_rev_series.push(res_revenue_prev[i]);
                cur_sc_series.push(res_scontrini[i]);
                prev_sc_series.push(res_scontrini_prev[i]);
            }

            this.chart_revenue.options = this.buildChartOption('customers.chart_revenue_title', '€', 'customers.chart_revenue_label', category, cur_rev_series, prev_rev_series);
            this.chart_scontrini.options = this.buildChartOption('customers.chart_scontrini_title', '', 'customers.chart_scontrini_label', category, cur_sc_series, prev_sc_series)

        });

        Observable.zip (
            this.indicatorService.getChart('customers.Q020', d, false)
        ).subscribe( (res) => {
            let category_ac_cp = [];
            let ac_cur_series = [];
            let cp_cur_series = [];
            let ac_prev_series = [];
            let cp_prev_series = [];
            let res_year = res[0].series[0].serie;
            let res_month = res[0].series[1].serie;
            let res_active = res[0].series[2].serie;
            let res_active_prev = res[0].series[3].serie;
            let res_penetration = res[0].series[4].serie;
            let res_penetration_prev = res[0].series[5].serie;
            for (let i = 0; i < res_year.length; i++) {
                category_ac_cp.push(res_year[i] /*+ res_month[i]*/);
                ac_cur_series.push(res_active[i]);
                ac_prev_series.push(res_active_prev[i]);
                cp_cur_series.push(res_penetration[i]);
                cp_prev_series.push(res_penetration_prev[i]);
            }
            this.chart_active_customers.options = this.buildChartOption('customers.chart_active_customers', '', 'customers.chart_active_customers_label', category_ac_cp, ac_cur_series, ac_prev_series);
            this.chart_card_penetration.options = this.buildChartOption('customers.chart_card_penetration', '%', 'customers.chart_card_penetration_label', category_ac_cp, cp_cur_series, cp_prev_series);
        });

    }

    resetData () {
        this.show_results = false;
    }

    searchValue (data: QFilterModel) {
        let mode = (data.card_mode === 'TRUE' || data.card_mode === '' || data.card_mode === 'ALL') ? 'ALL' : 'FALSE';
        this.data = data;
        this.displayTrend (mode);
        this.show_results = true;
        this.type_results = mode;
    }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/revenue-analysis/trend/revenue-analysis-trend.component.ts